import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { HelperService } from '@core/helper/helper.service';
import { AuthenticationService } from '@core/services/auth.service';
import { Store } from '@ngrx/store';
import { credits, currentYear } from '@common/constants';
import { CommonModule } from '@angular/common';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmployeeActions } from '@/store/employee/employee.actions';
import {
  getPasswordChangedLoadingStatus,
  getPasswordChangedStatus,
} from '@/store/employee/employee.selectors';
import { Subscription } from 'rxjs';
export const confirmPasswordValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  return control.value.new_password === control.value.confirm_password
    ? null
    : { PasswordNoMatch: true };
};
@Component({
  selector: 'app-change-password',
  imports: [TranslatePipe, ReactiveFormsModule, CommonModule],
  templateUrl: './change-password.component.html',
  styles: ``,
})
export class ChangePasswordComponent implements OnInit, OnDestroy {
  activeModal = inject(NgbActiveModal);
  public store = inject(Store);
  public service = inject(AuthenticationService);
  public translateService = inject(TranslateService);
  public helperService = inject(HelperService);
  currentYear = currentYear;
  credits = credits;
  email: string = '';
  token: string = '';
  submit: boolean = false;
  isLoading: boolean = false;
  subscription: Subscription = new Subscription();
  passwordForm: FormGroup = new FormGroup(
    {
      current_password: new FormControl<string>('', [Validators.required]),
      new_password: new FormControl<string>('', [
        Validators.required,
        Validators.minLength(8),
      ]),
      confirm_password: new FormControl<string>('', [
        Validators.required,
        Validators.minLength(8),
      ]),
    },
    { validators: confirmPasswordValidator }
  );
  constructor() {}

  ngOnInit(): void {
    this.subscription.add(
      this.store
        .select(getPasswordChangedLoadingStatus)
        .subscribe((isLoading) => {
          this.isLoading = isLoading;
        })
    );

    this.subscription.add(
      this.store.select(getPasswordChangedStatus).subscribe((isUpdated) => {
        if (isUpdated) {
          this.helperService.showSuccessToastr(
            this.translateService.instant('Password changed successfully')
          );
          this.store.dispatch(EmployeeActions.resetFlags());
          this.activeModal.close();
        }
      })
    );
  }
  updatePassword() {
    this.submit = true;
    if (this.passwordForm.valid) {
      this.store.dispatch(
        EmployeeActions.changePassword({
          ...this.passwordForm.value,
        })
      );
    }
  }

  // check if a specific control has a specific error and if it was touched
  hasError(controlName: string, errorName: string) {
    return this.passwordForm.get(controlName)?.hasError(errorName);
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
